import React from 'react';
import SharedPricingCards from '../../components/Pricing/SharedPricingCards';

interface MobileUpgradeProps {
    plans: any[];
    promoCode: string;
    setPromoCode: (v: string) => void;
    isApplying: boolean;
    promoError: string | null;
    promoSuccess: string | null;
    handleApplyPromo: () => void;
    handlePayment: (planId: string) => void;
    paymentLoading: boolean;
    navigate: (path: string) => void;
}

const MobileUpgrade: React.FC<MobileUpgradeProps> = ({
    plans, promoCode, setPromoCode, isApplying, promoError, promoSuccess,
    handleApplyPromo, handlePayment, paymentLoading, navigate
}) => {
    const getButtonLabel = (plan: any) => {
        if (plan.current) return 'Plan actuel';
        if (paymentLoading) return 'Redirection...';
        if (plan.planId === 'gratuit') return 'Plan actuel';
        return 'S\'abonner';
    };



    return (
        <div style={{ paddingBottom: '30px', background: 'var(--bg-main)' }}>
            {/* Compact Header Section - Mobile */}
            <div style={{
                textAlign: 'center', padding: '20px 16px',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white',
                boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
            }}>
                <h1 style={{ fontSize: '1.3rem', fontWeight: '800', margin: '0 0 8px 0' }}>
                    🚀 Kanea Pro
                </h1>
                <p style={{ fontSize: '0.85rem', opacity: 0.9, margin: '0 0 10px 0', lineHeight: '1.4' }}>
                    Des outils professionnels pour les investisseurs exigeants.
                </p>
                <div style={{ height: '1px', background: 'rgba(255,255,255,0.2)', width: '40px', margin: '8px auto' }}></div>
                <p style={{ fontSize: '0.95rem', fontStyle: 'italic', margin: 0, opacity: 0.95, lineHeight: '1.4' }}>
                    "Parce que la bonne action, c'est la bonne information. Obtenez un temps d'avance sur le marché."
                </p>
            </div>

            {/* Pricing Cards */}
            <div style={{ padding: '15px 12px' }}>
                <SharedPricingCards 
                    plans={plans} 
                    onPlanAction={(planId) => planId !== 'gratuit' ? handlePayment(planId) : null}
                    getButtonLabel={getButtonLabel}
                    isPaymentLoading={paymentLoading}
                    layout="mobile"
                />
            </div>

            {/* Bottom Sections - Ultra Compact */}
            <div style={{ padding: '0 12px', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                {/* Promo Section */}
                <div style={{
                    padding: '15px', background: 'var(--bg-box)', borderRadius: '12px',
                    border: '1px solid var(--border-color)', textAlign: 'center', boxShadow: '0 2px 8px var(--shadow-color)'
                }}>
                    <h4 style={{ fontSize: '0.9rem', fontWeight: '700', color: 'var(--text-heading)', marginBottom: '10px' }}>
                        🎁 Code Promo ?
                    </h4>
                    <div style={{ display: 'flex', gap: '8px' }}>
                        <input
                            type="text" value={promoCode}
                            onChange={(e) => setPromoCode(e.target.value.toUpperCase())}
                            placeholder="CODE"
                            style={{
                                flex: 1, padding: '10px', borderRadius: '8px',
                                border: '1px solid var(--border-color)', background: 'var(--bg-input)',
                                color: 'var(--text-main)', fontSize: '0.9rem', outline: 'none',
                                textAlign: 'center', fontWeight: '600'
                            }}
                        />
                        <button
                            onClick={handleApplyPromo}
                            disabled={isApplying || !promoCode.trim()}
                            style={{
                                padding: '10px 15px', borderRadius: '8px', fontSize: '0.9rem', fontWeight: '700',
                                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', color: 'white',
                                border: 'none', cursor: 'pointer', transition: 'all 0.2s',
                            }}
                        >
                            {isApplying ? '...' : 'Valider'}
                        </button>
                    </div>
                </div>

                {/* B2B Section */}
                <div style={{
                    background: 'var(--bg-hover)', padding: '15px', borderRadius: '12px',
                    textAlign: 'center', border: '1px solid var(--border-color)',
                }}>
                    <h3 style={{ fontSize: '1rem', fontWeight: '700', color: 'var(--text-heading)', marginBottom: '5px' }}>
                        🏢 Licences B2B
                    </h3>
                    <p style={{ fontSize: '0.8rem', color: 'var(--text-main)', margin: '0 0 10px 0' }}>
                        SGI ou institution ? Contactez-nous.
                    </p>
                    <button
                        onClick={() => navigate('/settings/contacts?subject=b2b')}
                        style={{
                            width: '100%', padding: '10px', background: 'transparent',
                            color: 'var(--text-heading)', border: '1px solid var(--text-heading)',
                            borderRadius: '8px', fontSize: '0.85rem', fontWeight: '600'
                        }}
                    >
                        📞 Nous contacter
                    </button>
                </div>
            </div>

            {/* Payment Info */}
            <div style={{ padding: '12px 16px', textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.8rem', lineHeight: '1.5', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                <span>🔒</span>
                <p style={{ margin: 0 }}>Paiements sécurisés — PayDunia</p>
            </div>
        </div>
    );
};

export default MobileUpgrade;
